<template>
  <div>
    <slot name="header">
      <div :class="['header-box',{'header-box1':showQuery}]">
        <div
          v-if="filterHannleItems&&filterHannleItems.length"
          class="header-item header-item-hannle"
        >
          <Button
            v-for="(item,index) in filterHannleItems"
            :key="index"
            type="primary"
            v-bind="item"
            style="margin-right: 10px;"
            v-on="item.on"
          >
            {{ item.title }}
          </Button>
        </div>
        <div
          v-if="formItems && formItems.length"
          class="header-item header-item-search"
        >
          <Form
            ref="form"
            inline
            :label-width="labelWidth"
            label-position="left"
            :model="currentValue"
          >
            <MyFormItemList
              v-model="currentValue"
              inline
              :list="formItems"
              :label-width="labelWidth"
              :form-item-width="formItemWidth"
              :label-colon="labelColon"
            >
              <slot name="searchBtnAfter">
                <FormItem
                  :label-width="0"
                >
                  <Button
                    v-if="showQuery"
                    type="primary"
                    style="margin-right: 10px;"
                    :loading="loading"
                    @click="getList(1)"
                  >
                    查询
                  </Button>

                  <Button
                    v-if="exportItem && exportItem.title"
                    type="primary"
                    :loading="exportItem.loading"
                    @click="exportItem.on.click"
                  >
                    导出
                  </Button>
                </FormItem>
              </slot>
            </MyFormItemList>
          </Form>
        </div>
      </div>
    </slot>
    <slot name="tableTop">
    </slot>
    <Table
      :columns="currentColumns"
      :data="rows"
      style="overflow: unset;"
      :loading="loading"
      :show-summary="showSummary"
      :summary-method="$attrs['summary-method']"
      :border="border"
      @on-selection-change="onSelectionChange"
      @on-sort-change="onSortChange"
    ></Table>
    <div
      v-if="showPage"
      class="page-box"
    >
      <slot
        name="total"
        :total="total"
      ></slot>
      <Page
        :total="currentTotal"
        show-sizer
        :current="currentValue.page"
        :page-size="currentValue.limit"
        @on-page-size-change="onPageSizeChange"
        @on-change="onChange"
      />
    </div>
  </div>
</template>

<script>


export default {
  name: 'TablePage',
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    showQuery: {
      type: Boolean,
      default: true,
    },
    autoload: {
      type: Boolean,
      default: true,
    },
    loadData: {
      type: Function,
      default: () => {
        return '';
      },
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    // summaryMethod: {
    //   type: Function,
    //   default: () => {
    //     return null;
    //   },
    // },
    hannleItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
    formItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
    exportItem: {
      type: Object,
      default: () => {
        return {
          on: {

          },
        };
      },
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    labelWidth: {
      type: Number,
      default: 100,
    },
    formItemWidth: {
      type: Number,
      default: 0,
    },
    labelColon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTotal: this.total,
      rows: this.data,
      currentValue: this.value,
      loading: false,
      currentColumns: [],
    };
  },
  computed: {
    filterHannleItems() {
      return this.hannleItems;
    },
  },
  watch: {
    columns: {
      handler() {
        const currentColumns = [];
        this.columns.forEach((ele) => {
          const item = { ...ele };
          if (typeof item.asyncRender === 'function') {
            item.asyncRender(item);
          }
          currentColumns.push(item);
        });
        this.currentColumns = currentColumns;
      },
      deep: true,
      immediate: true,
    },
    value() {
      if (this.currentValue !== this.value) {
        this.currentValue = this.value;
      }
    },
    currentValue(val) {
      if (this.currentValue !== this.value) {
        this.$emit('input', val);
      }
    },
  },
  created() {
    if (this.autoload) {
      // 获取数据
      this.getList();
    }
  },
  methods: {
    getList(page) {
      if (page) {
        this.currentValue.page = page;
      }
      if (this.loadData && typeof this.loadData === 'function') {
        this.loading = true;
        this.loadData((res) => {
          this.loading = false;
          if (res) {
           
            if (res.success) {
              const { rows, total } = res.data;
              this.currentTotal = total || 0;
              this.rows = rows || [];
            } else {
            // this.total = 0;
            // this.rows = [];
              this.$Message.error(res.message || '请求出错');
            }
          }
        });
      }
    },
    clear() {
      this.currentTotal = 0;
      this.rows = [];
    },
    onChange(page) {
      this.getList(page);
    },
    onPageSizeChange(limit) {
      this.currentValue.limit = limit;
      this.getList(1);
    },
    onSelectionChange(selection) {
      this.$emit('on-selection-change', selection);
    },
    onSortChange({ key, order }) {
      if (order === 'normal') {
        delete this.currentValue.sort;
      } else {
        this.currentValue.sort = `${key} ${order}`;
      }

      this.getList(1);
    },
  },

};
</script>

<style scoped lang="less">
    // .table-box{
    //     background-color: #fff;
    //     box-sizing: border-box;
    //     padding: 20px;
    // }
    .page-box {
      padding: 10px 0;
      text-align: right;
      // background: #f8f8f9;
    }
    .header-box {
      display: flex;
      justify-content: space-between;
    }
    .header-box1 {
      flex-flow: column-reverse;
      .header-item-hannle {
        margin-bottom: 20px;
      }
    }
</style>
